const globalTranslations = {
  no: {
    owner: 'Eier',
    created: 'Opprettet',
    canvascourse: 'Canvas emne',
    name: 'Uten navn',
    permalink: 'permalink',
    description: 'Beskrivelse',
    task: 'Oppgaver',
    defaulttask: 'Oppgave uten navn',
    addtask: 'Legg til oppgave',
    canvasplaceholder: 'Canvas emne',
    subjectplaceholder: 'Emne',
    notags: 'Ingen emneknagger',
    cancel: 'Avbryt',
    accept: 'Bekreft',
    done: 'Lagre',
    back: 'Tilbake',
    send: 'Send',
    save: 'Lagre',
    add: 'Legg til',
    remove: 'Ta ned',
    edit: 'Rediger',
    continue: 'Fortsett',
    ready: 'Klar',
    start: 'Start',
    next: 'Neste',
    previous: 'Forrige',
    close: 'Lukk',
    login: 'Logg på',
    logout: 'Logg av',
    join: 'Delta',
    organize: 'Organiser',
    copy: 'Ta kopi',
    copyOf: 'Kopi av',
    to: 'Til',
    confirm: 'OK',
    image: 'bilde',
    copiedtoclipboard: 'Teksten ble kopiert',
    mqtterror: 'Mistet forbindelse til tjeneren, kan ikke oppdatere',
    loading: 'Laster inn ...',
    notowner: 'Det vises mindre innhold her fordi du ikke eier denne tavlen',
    fullsize: 'Vis i full størrelse',
    duplicate: 'Dupliser',
    deletionwarning: 'Vil du slette denne tavlen? Dette kan ikke angres.',
    deletionwarningnote: 'Vil du slette dette bidraget? Dette kan ikke angres.',
    duplicationwarning: 'Vil du ta kopi av denne tavlen?',
    lockwarning: 'Vil du låse tavlen? Deltagerne kan da bare lese og ikke redigere bidrag.',
    unlockwarning: 'Vil du låse opp denne tavlen? Deltagerne kan da legge til og redigere bidrag.',
    delete: 'Slett',
    nopreview: 'Ingen forhåndsvisning',
    leavingTalkwallWarning: 'Vil du åpne en annen nettside? Fortsett hvis du kjenner nettsiden.',
    showTutorial: 'Vis guiden',
    boardRegion: 'Tavle',
    boardKeyboardHint:
      'Piltaster flytter visningen, pluss og minus zoomer, 0 tilbakestiller zoom. Tab til et bidrag og trykk mellomrom for å velge det. Piltaster flytter valgte bidrag, Escape fjerner valget.',
    noteSelected: 'Bidrag valgt. {n} valgt.',
    noteDeselected: 'Bidrag fjernet fra valget. {n} valgt.',
    selectionCleared: 'Valget er fjernet.',
    notesMoved: 'Flyttet {n} bidrag.',
    scrapeUnsuccessful: 'Lenken er ugyldig.',
    selectimage: 'Velg et bilde',
    oppgaveDescription: 'Deltagerne kan enten bidra på en felles tavle, eller på egen eller andre tavler',
    all: 'Flere tavler',
    onlyGroup: 'En tavle',
    placeholder: 'Skriv noe...',
    defaultdescription: 'Legg til en bildebeskrivelse her',
    filetoolarge: 'Valgt fil er for stor. Vennligst velg en fil under 5MB størrelse.',

    createnote: 'Legg til bidraget',
    notitle: 'Ingen tittel tilgjengelig',
    nodesc: 'Ingen beskrivelse tilgjengelig',
    templates: 'Kopier tavle',
    templatenotice: 'Du er i ferd med å ta kopi av denne tavlen.',
    nosubjects: 'Ingen emner valgt',
    nowallssearch: 'Ingen resultater for søket ditt.',
    search: 'Søk',
    alreadychosen: 'Allerede valgt',
    addsubject: 'Legg til navn på emne',
    addicon: 'Velg ikon',
    lockedwall: 'Denne tavlen ble låst',
    download: 'Last ned dokumentet',
    resources: 'Ressurser',
    belongsTo: 'Tilhører',
    subject: 'Legg til emne',
    board: 'Tavle',
    export: 'Eksporter',
    createpin: 'Opprett PIN',
    deletepin: 'Slett PIN',
    nothingtodisplay: 'Ingenting å vise',
    sharedinfeide: 'Delt via Feide',
    sharedincanvas: 'Delt via Canvas',
    allwalls: 'Alle tavler',
    sharedwalls: 'Delte tavler',
    mywalls: 'Mine tavler',
    trashedwalls: 'Slettete tavler',
    subjects: 'Emner',
    welcomeback: 'Startside',
    reloadduetotimeout: 'Det har gått for lang tid. Du er koblet fra.',
    boardcreationfailed: 'Noe gikk galt ved oppsettelse av tavlen',
    reload: 'Prøv igjen',
    sendUsYourFeedback: 'Gi oss tilbakemelding om Samtavla',

    'aria-navigate-next': 'Neste Oppgave',
    'aria-navigate-previous': 'Siste Oppgave',
    'aria-file-export': 'eksportalternativer',
    'aria-notifications': 'varsler',
    'aria-info-options': 'informasjonsalternativer',
    'aria-wall-options': 'Tavle redigeringsalternativer',
    'aria-sharing-options': 'delingsalternativer',
    'aria-main-menu': 'Hovedmeny',
    'aria-open-search': 'åpen søke',
    'aria-close-search': 'lukke søke',
    'aria-new-wall': 'Ny tavle',
    'aria-new-note': 'Ny notat',
    'aria-filter': 'Filter',
    'aria-search': 'Søk',
    'aria-status-attachment': 'Har vedlegg',
    'aria-status-pin': 'Har pin',
    'aria-status-link': 'Har lenk',
    'aria-status-tag': 'Har tag',
    'aria-status-origins': 'opprinnelse',
    'aria-status-history': 'historie',
    'aria-expand-section': 'Utvid seksjonen',
    'aria-access-locked': 'Denne tavle er skrivebeskyttet',
    'aria-access-authonly': 'kun for autoriserte brukere',
    'aria-view-filtering': 'sorter visning etter',
    'aria-image-preview': 'forhåndsvisningsbilde',
    'aria-edit-note': 'Rediger notat',
    'shift-enter-confirm': 'Shift+Enter for å bekrefte',
    'aria-note-menu': 'notat meny',
    'aria-note-info': 'notat mer info',
    'aria-remove-note': 'Slett notat',
    'aria-note-preview-image': 'Forhåndsvisningsbilde',
    'aria-zoom-in': 'Zoom inn',
    'aria-zoom-out': 'Zoom ut',
    'aria-close': 'Lukke',
    'aria-user-icon': 'Bruker icon',
    exportCreatedBy: 'Laget av',
    exportEditedBy: 'Redigert av',
  },
  en: {
    owner: 'Owner',
    created: 'Created',
    canvascourse: 'Canvas course',
    name: 'Untitled',
    permalink: 'permalink',
    description: 'Description',
    task: 'Tasks',
    defaulttask: 'Default task',
    addtask: 'Add task',
    canvasplaceholder: 'Canvas course',
    subjectplaceholder: 'Subject',
    notags: 'No tags',
    cancel: 'Cancel',
    accept: 'Accept',
    done: 'Save',
    back: 'Back',
    send: 'Send',
    save: 'Save',
    add: 'Add',
    remove: 'Unpin',
    edit: 'Edit',
    continue: 'Continue',
    ready: 'Ready',
    start: 'Start',
    next: 'Next',
    previous: 'Previous',
    close: 'Close',
    login: 'Login',
    logout: 'Logout',
    join: 'Join',
    organize: 'Organise',
    copy: 'Copy',
    copyOf: 'Copy of',
    to: 'To',
    confirm: 'OK',
    image: 'image',
    copiedtoclipboard: 'Copied to clipboard',
    mqtterror: 'Lost connection to server, can not update',
    loading: 'Loading',
    notowner: 'The options here are restricted as you are not the owner of this wall',
    fullsize: 'Show in full size',
    duplicate: 'Duplicate',
    deletionwarning: 'Do you want to delete this wall? This cannot be undone.',
    deletionwarningnote: 'Do you want to delete this contribution? This cannot be undone.',
    duplicationwarning: 'Do you want to duplicate this wall?',
    lockwarning: 'Do you want to lock this wall? Participants can only read, and not modify contributions.',
    unlockwarning: 'Do you want to unlock this wall? Participants may add and modify contributions.',
    delete: 'Delete',
    nopreview: 'No preview',
    leavingTalkwallWarning: 'Do you want to open another website? Only proceed if the page is familiar.',
    showTutorial: 'Show the guide',
    boardRegion: 'Board',
    boardKeyboardHint:
      'Arrow keys move the view, plus and minus zoom, 0 resets the zoom. Tab to a contribution and press Space to select it. Arrow keys move the selected contributions, Escape clears the selection.',
    noteSelected: 'Contribution selected. {n} selected.',
    noteDeselected: 'Contribution deselected. {n} selected.',
    selectionCleared: 'Selection cleared.',
    notesMoved: 'Moved {n} contributions.',
    scrapeUnsuccessful: 'The link is invalid',
    selectimage: 'Choose an image',
    oppgaveDescription: 'Participants can either contribute on a shared board, or on their own or other boards.',
    placeholder: 'Write something...',
    defaultdescription: 'Add an image description here',
    all: 'Multiple walls',
    onlyGroup: 'One wall',
    filetoolarge: 'The chosen file is too big. Please choose an image smaller than 5MB in size',

    createnote: 'Create contribution',
    notitle: 'No title available',
    nodesc: 'No description available',
    templates: 'Copy wall',
    templatenotice: 'You are about to make a copy of this wall.',
    nosubjects: 'No subjects chosen',
    nowallssearch: 'No results for this search.',
    search: 'Search',
    alreadychosen: 'Already chosen',
    addsubject: 'Add subject name',
    addicon: 'Add icon',
    lockedwall: 'This wall has been locked',
    download: 'Download document',
    resources: 'Resources',
    subject: 'Add subject',
    belongsTo: 'Belongs to',
    board: 'Wall',
    export: 'Export',
    createpin: 'Create PIN',
    deletepin: 'Delete PIN',
    nothingtodisplay: 'Nothing to display',
    sharedinfeide: 'Shared via Feide',
    sharedincanvas: 'Shared via Canvas',
    allwalls: 'All walls',
    sharedwalls: 'Shared walls',
    mywalls: 'My walls',
    trashedwalls: 'Deleted walls',
    subjects: 'Subjects',
    welcomeback: 'Dashboard',
    reloadduetotimeout: 'Reloaded due to timeout',
    boardcreationfailed: 'Board creation failed',
    reload: 'Try again',
    exportCreatedBy: 'Created by',
    exportEditedBy: 'Edited by',
    sendUsYourFeedback: 'Send us your feedback!',

    'aria-navigate-next': 'Next Task',
    'aria-navigate-previous': 'Previous Task',
    'aria-file-export': 'Export options',
    'aria-notifications': 'Notification options',
    'aria-info-options': 'Info options',
    'aria-wall-options': 'Wall Editing options',
    'aria-sharing-options': 'Sharing options',
    'aria-main-menu': 'Main menu',
    'aria-open-search': 'Open search',
    'aria-close-search': 'Close search',
    'aria-new-wall': 'New wall',
    'aria-new-note': 'New note',
    'aria-filter': 'Filter',
    'aria-search': 'Search',
    'aria-status-attachment': 'Has attachment',
    'aria-status-pin': 'Is pinned',
    'aria-status-link': 'has a link',
    'aria-status-tag': 'Has a tag',
    'aria-status-history': 'History',
    'aria-status-origins': 'Origins',
    'aria-expand-section': 'Expand section',
    'aria-access-locked': 'This wall is read-only',
    'aria-access-authonly': 'kun for autoriserte brukere',
    'aria-view-filtering': 'Sort view by',
    'aria-image-preview': 'preview image',
    'aria-edit-note': 'Edit note',
    'shift-enter-confirm': 'Shift+Enter to confirm',
    'aria-note-menu': 'Note menu',
    'aria-note-info': 'note more info',
    'aria-remove-note': 'Remove note',
    'aria-note-preview-image': 'Preview image',
    'aria-zoom-in': 'Zoom in',
    'aria-zoom-out': 'Zoom out',
    'aria-close': 'Close',
    'aria-user-icon': 'User icon',
  },
}

export { globalTranslations }
